"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var Login_vue_1 = __importDefault(require("@/components/login/Login.vue"));
var filters_1 = require("@/filter/filters");
var VendorCompanyAccess_vue_1 = __importDefault(require("@/components/vendor-company-access/VendorCompanyAccess.vue"));
var LanguageSelector_vue_1 = __importDefault(require("@/components/language-selector/LanguageSelector.vue"));
var parameters_1 = __importDefault(require("@/config/parameters"));
var NavigationBarUserWidget_vue_1 = __importDefault(require("@/components/navigation-bar-user-widget/NavigationBarUserWidget.vue"));
var NavigationBar = /** @class */ (function (_super) {
    __extends(NavigationBar, _super);
    function NavigationBar() {
        var _this = _super.call(this) || this;
        _this.userData = null;
        _this.partnership = null;
        return _this;
    }
    NavigationBar.prototype.mounted = function () {
        var _this = this;
        this.loadUserData();
        this.loadPartnershipData();
        this.$root.$on('AUTHENTICATED_EVENT', this.loadUserData);
        this.$root.$on('USER_DATA_UPDATED', this.loadUserData);
        this.$root.$on('PARTNERSHIP_SELECTED', this.loadPartnershipData);
        this.$root.$on('PARTNERSHIP_UNSELECTED', function () {
            _this.partnership = null;
        });
        this.$root.$on('SESSION_DESTROY_EVENT', function () {
            _this.userData = null;
        });
    };
    NavigationBar.prototype.loadPartnershipData = function () {
        var _this = this;
        var slug = this.$browserStorage.getCookie('slug');
        if (!slug) {
            return;
        }
        this.$getPartnershipDataService.request(slug).then(function (response) {
            _this.partnership = response;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    NavigationBar.prototype.loadUserData = function () {
        var _this = this;
        if (this.$oAuth2.getSessionId()) {
            this.$getUserDataService.request().then(function (response) {
                _this.userData = response;
            }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
        }
    };
    NavigationBar.prototype.goToNarrativesBackoffice = function () {
        window.open(parameters_1.default.narratives.host_backoffice + '/' + this.$route.params.partnershipSlug + '/search-series/1', '_blank');
    };
    NavigationBar.prototype.redirectToProjectWebAddress = function () {
        window.open(parameters_1.default.projectWebAddress, '_blank');
    };
    NavigationBar = __decorate([
        vue_property_decorator_1.Component({
            name: 'NavigationBar',
            components: {
                Login: Login_vue_1.default,
                VendorCompanyAccess: VendorCompanyAccess_vue_1.default,
                LanguageSelector: LanguageSelector_vue_1.default,
                NavigationBarUserWidget: NavigationBarUserWidget_vue_1.default
            },
            filters: {
                capitalize: filters_1.capitalize
            }
        })
    ], NavigationBar);
    return NavigationBar;
}(vue_1.default));
exports.default = NavigationBar;
